import { render } from "./aio-login-ip-address.vue?vue&type=template&id=f9bdde84&scoped=true"
import script from "./aio-login-ip-address.vue?vue&type=script&lang=js"
export * from "./aio-login-ip-address.vue?vue&type=script&lang=js"

import "./aio-login-ip-address.vue?vue&type=style&index=0&id=f9bdde84&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f9bdde84"]])

export default __exports__